import { c as _c } from "react/compiler-runtime";
import type { IntendedAlertMessage } from '@module/types/centrifuge/public-message/etcMessageTypes';
import type { CustomMuteOnMessage } from '@module/types/centrifuge/public-message/muteMessageTypes';
import { BaseHttpResponseError } from '@module/utils/error/apiErrors';
import { useState } from 'react';
import useChatMessageStore from '../../stores/useChatMessageStore';
import useMuteStore from '../../stores/useMuteStore';
interface UseChatErrorHandlerParams {
  onFreezeOnError?: (message: string) => void;
  messageOnPaperingOnError: string;
  messageOnUnexpectedChatError: string;
}

/**
 * 채팅 전송 에러 처리 + 도배(papering)/채팅금지(mute) 차단 시각 상태를 담당한다.
 *
 * - appendChatErrorMessage: 채팅창에 안내 메시지를 끼워넣는다.
 * - handleChatMessageError: 서버 에러 코드(Freeze/Papering/Mute)별 처리.
 * - paperingBlockTime / muteTime: 전송 진입점에서 차단 여부 판단에 사용.
 *
 * 동작은 useChatComposer의 기존 에러 처리 로직과 동일하다.
 */
const useChatErrorHandler = t0 => {
  const $ = _c(14);
  const {
    onFreezeOnError,
    messageOnPaperingOnError,
    messageOnUnexpectedChatError
  } = t0;
  const [paperingBlockTime, setPaperingBlockTime] = useState(0);
  const setChatMessages = useChatMessageStore(_temp);
  const muteTime = useMuteStore(_temp2);
  const setMuteTime = useMuteStore(_temp3);
  let t1;
  if ($[0] !== setChatMessages) {
    t1 = message => {
      setChatMessages(prev => {
        const now = Date.now();
        const newPayload = {
          data: {
            type: "IntendedAlert",
            message
          },
          offset: now
        };
        return [...prev, newPayload];
      });
    };
    $[0] = setChatMessages;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const appendChatErrorMessage = t1;
  let t2;
  if ($[2] !== appendChatErrorMessage || $[3] !== messageOnPaperingOnError || $[4] !== messageOnUnexpectedChatError || $[5] !== onFreezeOnError || $[6] !== setChatMessages || $[7] !== setMuteTime) {
    t2 = error => {
      if (!(error instanceof BaseHttpResponseError)) {
        appendChatErrorMessage(messageOnUnexpectedChatError);
        return;
      }
      const {
        errorData
      } = error.serverResponse;
      if (!errorData?.code) {
        appendChatErrorMessage(error.message || messageOnUnexpectedChatError);
        return;
      }
      switch (errorData.code) {
        case "FreezeOn":
          {
            onFreezeOnError?.(error.serverResponse.message);
            return;
          }
        case "PaperingOn":
          {
            appendChatErrorMessage(messageOnPaperingOnError);
            setPaperingBlockTime(errorData.paperingBlockTime ?? 0);
            return;
          }
        case "MuteOn":
          {
            const now_0 = Date.now();
            setMuteTime(errorData.muteTime || 0);
            setChatMessages(prev_0 => {
              const newMutePayload = {
                data: {
                  type: "CustomMuteOn",
                  message: {
                    idx: errorData.idx || 0,
                    muteTime: errorData.muteTime || 0
                  },
                  created_at: now_0
                },
                offset: now_0
              };
              return [...prev_0, newMutePayload];
            });
            return;
          }
      }
    };
    $[2] = appendChatErrorMessage;
    $[3] = messageOnPaperingOnError;
    $[4] = messageOnUnexpectedChatError;
    $[5] = onFreezeOnError;
    $[6] = setChatMessages;
    $[7] = setMuteTime;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const handleChatMessageError = t2;
  let t3;
  if ($[9] !== appendChatErrorMessage || $[10] !== handleChatMessageError || $[11] !== muteTime || $[12] !== paperingBlockTime) {
    t3 = {
      appendChatErrorMessage,
      handleChatMessageError,
      paperingBlockTime,
      muteTime
    };
    $[9] = appendChatErrorMessage;
    $[10] = handleChatMessageError;
    $[11] = muteTime;
    $[12] = paperingBlockTime;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};
export default useChatErrorHandler;
function _temp(state) {
  return state.setChatMessages;
}
function _temp2(state_0) {
  return state_0.muteTime;
}
function _temp3(state_1) {
  return state_1.setMuteTime;
}